export default __webpack_public_path__ + "static/media/check_icon.92755874.svg";